import { HandlerWithResult } from "@gtsanders/Store/GTSState";
import { UploadedItemDynamic } from "@gtsanders/Store/Pages/OrderUpload/Handlers/ProcessFileWithDynamicColumnMapping";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { UploadedItem } from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";

export interface DynamicMappingParameter {
    mapper: HeadingMapper;
    uploadedItemsDynamic: UploadedItemDynamic[];
}

export interface HeadingMapper{
    itemNumberIndex: number;
    quantityIndex: number;
    unitOfMeasureIndex: number;
}

export interface ProcessFileResult {
    uploadedItems: UploadedItem[];
    uploadLimitExceeded: boolean;
    isBadFile: boolean;
    isUploading: boolean;
    allowCancel: boolean;
}

type HandlerType = HandlerWithResult<DynamicMappingParameter, ProcessFileResult>;

export const CreateDefaultResult: HandlerType = props => {
    props.result = {
        uploadedItems: [],
        uploadLimitExceeded: false,
        isBadFile: false,
        isUploading: false,
        allowCancel: false,
    };
};

export const ProcessUploadedFile: HandlerType = async props => {
    props.parameter.uploadedItemsDynamic.forEach((item, index) => {
        if(index > 0){
            if(item.column[props.parameter.mapper.itemNumberIndex].length === 0 || 
                isNaN(Number(item.column[props.parameter.mapper.quantityIndex]))){
                return;
            }
            var tempNewItemMapped =  {
                name: item.column[props.parameter.mapper.itemNumberIndex],
                qtyOrdered: Number(item.column[props.parameter.mapper.quantityIndex]),
                unitOfMeasure: item.column[props.parameter.mapper.unitOfMeasureIndex],
            } as UploadedItem;
            props.result.uploadedItems.push(tempNewItemMapped);
        }
    });
};
export const DispatchCompleteProcessFile: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderUpload/CompleteProcessDynamicMapping",
        result: props.result,
    });
};

export const chain = [CreateDefaultResult, ProcessUploadedFile, DispatchCompleteProcessFile];

const mapDynamicOrderToTemplate = createHandlerChainRunner(chain, "MapDynamicOrderToTemplate");
export default mapDynamicOrderToTemplate;
